module.exports = __webpack_public_path__ + "img/upload.adc8f1d6.svg";